import moment from 'moment';
import { filterToParams, paramsToFilter, mergeFilterSearch } from '@/util/master/filterQuery';

// Filter bersama ikut URL. Pemakai isi `filterUrlGroups`, lalu panggil
// syncFilterUrl() habis load pertama & tiap Apply.
export default {
  created() {
    const groups = this.$options.filterUrlGroups;
    if (groups) this.applyFilterFromUrl(groups);
  },
  methods: {
    // Jalan sebelum DataFilter mount, jadi form-nya langsung kebaca.
    applyFilterFromUrl(groups) {
      const parsed = paramsToFilter(new URLSearchParams(window.location.search), groups);
      if (parsed.massId !== undefined) {
        // Aset udah kemuat -> pake massId aslinya, jangan string mentah dari URL.
        const assets = this.$store.getters['asset/assets'] || [];
        const known = (Array.isArray(assets) ? assets : Object.values(assets))
          .find((asset) => String(asset.massId) === parsed.massId);
        this.$store.dispatch('filter/setCurrentMassId', known ? known.massId : parsed.massId);
      }
      if (parsed.interval) this.$store.dispatch('filter/setInterval', parsed.interval);
      if (parsed.rangeType === 'custom') {
        this.$store.dispatch('filter/setCustomDate', { start: moment(parsed.startMs), end: moment(parsed.endMs) });
      } else if (parsed.rangeType) {
        this.$store.dispatch('filter/setRangeType', parsed.rangeType);
      }
    },
    syncFilterUrl() {
      const groups = this.$options.filterUrlGroups;
      if (!groups || this._isDestroyed || this._isBeingDestroyed) return;
      const { start, end } = this.$store.getters['filter/date'];
      const params = filterToParams({
        massId: this.$store.getters['filter/currentMassId'],
        rangeType: this.$store.getters['filter/rangeType'],
        startMs: moment(start).valueOf(),
        endMs: moment(end).valueOf(),
        interval: this.$store.getters['filter/interval'],
      }, groups);
      const search = mergeFilterSearch(window.location.search, params, groups);
      // Bukan router.replace: navigasi router bakal batalin request yang masih jalan.
      window.history.replaceState(window.history.state, '', `${window.location.pathname}${search}`);
      if (this.$refs.dataFilter) this.$refs.dataFilter.markApplied();
    },
  },
};
